class InitElevarDataLayerHelper {
  constructor({ userProperties, currentOrderProducts }) {
    // Ensure ElevarDataLayer exists
    if (!window.ElevarDataLayer) {
      window.ElevarDataLayer = []
    }

    if (!sessionStorage.landing_site) {
      sessionStorage.landing_site = window.location.href
    }

    // Set default properties from ElevarHelper
    this.userProperties = userProperties
    this.currentOrderProducts = currentOrderProducts
    this.currencyCode = window.SPREE_CURRENCY || 'USD'
    this.marketingLandingSite = sessionStorage.landing_site
  }

  /**
   * Push an event to the ElevarDataLayer
   * @param {string} eventName - Name of the event to push
   * @param {Object} additionalData - Additional data to include in the push
   */
  pushEvent(eventName, additionalData = {}) {
    const eventData = {
      event: eventName,
      user_properties: this.userProperties,
      ...additionalData
    }

    window.ElevarDataLayer.push(eventData)
    return eventData
  }

  /**
   * Push user data event
   * @param {number|string} cartTotal - Total value of the cart
   */
  pushUserData({ cartTotal = '0' }) {
    return this.pushEvent('dl_user_data', {
      cart_total: cartTotal,
      ecommerce: {
        currencyCode: this.currencyCode,
        cart_contents: {
          products: this.currentOrderProducts
        }
      }
    });
  }

  /**
   * Push checkout flow event handler
   * @param {string} eventName - Checkout event name
   * @param {string} step - Checkout step number
   */
  pushCheckoutFlow(eventName, step = '1') {
    return this.pushEvent(eventName, {
      ecommerce: {
        currencyCode: this.currencyCode,
        checkout: {
          actionField: {
            step: step
          },
          products: this.currentOrderProducts
        }
      }
    });
  }

  /**
   * Push begin checkout event
   */
  pushBeginCheckout() {
    return this.pushCheckoutFlow('dl_begin_checkout', '1')
  }

  /**
   * Push add shipping info event
   */
  pushAddShippingInfo() {
    return this.pushCheckoutFlow('dl_add_shipping_info', '2')
  }

  /**
   * Push add payment info event
   */
  pushAddPaymentInfo() {
    return this.pushCheckoutFlow('dl_add_payment_info', '3')
  }

  /**
   * Push purchase event
   * @param {Object} orderData - Order details including ID, revenue, tax, etc.
   * @param {Array} products - Products purchased
   */
  pushPurchase({ orderData }) {
    return this.pushEvent('dl_purchase', {
      ecommerce: {
        currencyCode: this.currencyCode,
        purchase: {
          actionField: { ...orderData },
          products: this.currentOrderProducts
        }
      },
      marketing: {
        landing_site: this.marketingLandingSite
      }
    });
  }

  /**
   * Push view item event
   * @param {Array} products - Viewed product
   */
  pushViewItem({ item, referer }) {
    return this.pushEvent('dl_view_item', {
      ecommerce: {
        currencyCode: this.currencyCode,
        detail: {
          actionField: {
            action: 'detail',
            ...(referer?.length && {
              list: referer // this should be the collection page URL that user clicked product from
            })
          },
          products: [item]
        }
      }
    });
  }

  /**
   * Push view item list event
   * @param {Array} impressions - Viewed products
   */
  pushViewItems({ impressions }) {
    return this.pushEvent('dl_view_item_list', {
      ecommerce: {
        currencyCode: this.currencyCode,
        impressions
      }
    });
  }
}

window.InitElevarDataLayerHelper = InitElevarDataLayerHelper
